import React from 'react'

import TopNavigation from './../molecules/navigation/topNavigation'

const Header = ({ onToggleMenu }) =>
  <React.Fragment>
    <TopNavigation onToggleMenu={onToggleMenu} />
  </React.Fragment>

export default Header
